




























































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storePersetujuanReuse } from "@/store/modules/PersetujuanReuseStore";
import PersetujuanReuseSvc from "@/services/PersetujuanReuse";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";

@Component({
  components: { CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPersetujuanReuse extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: "ranap" }) context!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean { return this.isReadOnly(); }

  showForm = false;
  isEditing = false;
  selectedItem: any = null;
  modalTtd = false;
  modalMark = false;
  markRole = "";
  markName = "";
  signRole = "";
  saving = false;
  deleting = false;
  formValid = false;
  menuTanggal = false;
  menuJam = false;
  menuPeriodeMulai = false;
  menuPeriodeSelesai = false;
  panels: number[] = [0, 1, 2, 3];

  form: any = this.getEmptyForm();

  tableHeaders = [
    { text: "Nomor", value: "nomor", width: "160" },
    { text: "Validitas", value: "validitas_mode", width: "120" },
    { text: "Tanggal", value: "tgl_tanda_tangan", width: "120" },
    { text: "Keputusan", value: "is_setuju", width: "100" },
    { text: "Status TTD", value: "status_ttd", width: "120" }
  ];

  validitasOptions = [
    { text: "Per-episode (1 tindakan/kunjungan)", value: "per_episode" },
    { text: "Per-modalitas (serangkaian sesi)", value: "per_modalitas" }
  ];
  hubunganOptions = [
    { text: "Pasien Sendiri", value: "pasien-sendiri" },
    { text: "Suami", value: "suami" },
    { text: "Istri", value: "istri" },
    { text: "Ayah", value: "ayah" },
    { text: "Ibu", value: "ibu" },
    { text: "Anak (≥18 thn)", value: "anak" },
    { text: "Saudara Kandung (≥18 thn)", value: "saudara" },
    { text: "Wali Sah", value: "wali" }
  ];

  mounted() {
    storePersetujuanReuse.getByRegister(this.register);
    storePersetujuanReuse.loadMasters();
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  emptyAlat() {
    return { nama: "", kategori_spaulding: null, reuse_ke: null, maks_reuse: null, metode_sterilisasi: null, kfa_kode: null, master_id: null };
  }

  getEmptyForm() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: userModule.user?.unit_id || null,
      context: this.context,
      validitas_mode: "per_episode",
      periode_mulai: null,
      periode_selesai: null,
      modalitas_label: "",
      tindakan_terkait: "",
      diagnosis: "",
      diagnosis_icd10: "",
      alat_list: [this.emptyAlat()],
      info_alasan_reuse: "",
      info_manfaat: "",
      info_risiko_infeksi: "",
      info_jaminan_mutu: "",
      info_alternatif_baru: "",
      info_konsekuensi_biaya: "",
      info_lain: "",
      bahasa: "id",
      tgl_info: localISODate(),
      jam_info: new Date().toTimeString().substr(0, 5),
      tempat_info: "",
      is_setuju: null,
      alasan_penolakan: "",
      rencana_pasca_penolakan: null,
      dpjp_user_id: null,
      penyetuju_nama: storePasien.identitasPasien?.nama || "",
      penyetuju_hubungan: "pasien-sendiri",
      penyetuju_nik: "",
      penyetuju_jenis_kelamin: null,
      penyetuju_alamat: "",
      saksi_keluarga_nama: "",
      saksi_rs_user_id: null,
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: localISODate(),
      jam_tanda_tangan: new Date().toTimeString().substr(0, 5)
    };
  }

  get loading() { return storePersetujuanReuse.loading; }
  get items() { return storePersetujuanReuse.items; }
  get masters() { return storePersetujuanReuse.masters; }
  get stateuser() { return userModule.user; }
  get dokterList() { return storeDokter.listAll; }

  spauldingLabel(kode: string): string {
    const f = (this.masters.spaulding || []).find((x: any) => x.kode === kode);
    return f ? f.label : "-";
  }

  addAlat() { this.form.alat_list.push(this.emptyAlat()); }
  removeAlat(i: number) {
    if (this.form.alat_list.length > 1) this.form.alat_list.splice(i, 1);
  }

  // Map metode sterilisasi master (mis. "ETO"/"Autoclave") → kode opsi select.
  normalizeMetode(val: any): string | null {
    if (!val) return null;
    const s = String(val).toLowerCase();
    if (s.includes("auto") || s.includes("uap")) return "autoclave";
    if (s.includes("eto") || s.includes("ethylene")) return "eto";
    if (s.includes("plasma") || s.includes("peroks")) return "plasma";
    if (s.includes("dtt") || s.includes("disinfeksi")) return "dtt";
    // sudah berupa kode opsi → pakai apa adanya
    const codes = (this.masters.metode_sterilisasi || []).map((x: any) => x.kode);
    return codes.indexOf(s) >= 0 ? s : "lainnya";
  }

  onPickMaster(row: any, val: any) {
    // v-combobox bisa emit string (return-object false) atau object item.
    const nama = val && typeof val === "object" ? val.nama_alat : val;
    row.nama = nama || "";
    const m = (this.masters.alat_master || []).find((x: any) => x.nama_alat === nama);
    if (!m) {
      row.master_id = null;
      return;
    }
    row.master_id = m.id;
    if (m.max_penggunaan) row.maks_reuse = Number(m.max_penggunaan);
    if (m.metode_sterilisasi) row.metode_sterilisasi = this.normalizeMetode(m.metode_sterilisasi);
  }

  selectItem(item: any) { this.selectedItem = item; }

  openCreateForm() {
    this.form = this.getEmptyForm();
    this.showForm = true;
  }

  startEdit() {
    const c = this.selectedItem;
    this.form = {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: c.unit_id || this.stateuser?.unit_id,
      context: c.context || this.context,
      validitas_mode: c.validitas_mode || "per_episode",
      periode_mulai: c.periode_mulai,
      periode_selesai: c.periode_selesai,
      modalitas_label: c.modalitas_label || "",
      tindakan_terkait: c.tindakan_terkait || "",
      diagnosis: c.diagnosis || "",
      diagnosis_icd10: c.diagnosis_icd10 || "",
      alat_list: (c.alat_list && c.alat_list.length) ? JSON.parse(JSON.stringify(c.alat_list)) : [this.emptyAlat()],
      info_alasan_reuse: c.info_alasan_reuse || "",
      info_manfaat: c.info_manfaat || "",
      info_risiko_infeksi: c.info_risiko_infeksi || "",
      info_jaminan_mutu: c.info_jaminan_mutu || "",
      info_alternatif_baru: c.info_alternatif_baru || "",
      info_konsekuensi_biaya: c.info_konsekuensi_biaya || "",
      info_lain: c.info_lain || "",
      bahasa: c.bahasa || "id",
      tgl_info: c.tgl_info,
      jam_info: c.jam_info,
      tempat_info: c.tempat_info || "",
      is_setuju: c.is_setuju,
      alasan_penolakan: c.alasan_penolakan || "",
      rencana_pasca_penolakan: c.rencana_pasca_penolakan,
      dpjp_user_id: c.dpjp?.id || null,
      penyetuju_nama: c.penyetuju_nama,
      penyetuju_hubungan: c.penyetuju_hubungan || "pasien-sendiri",
      penyetuju_nik: c.penyetuju_nik || "",
      penyetuju_jenis_kelamin: c.penyetuju_jenis_kelamin,
      penyetuju_alamat: c.penyetuju_alamat || "",
      saksi_keluarga_nama: c.saksi_keluarga_nama || "",
      saksi_rs_user_id: c.saksi_rs?.id || null,
      tempat_tanda_tangan: c.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: c.tgl_tanda_tangan,
      jam_tanda_tangan: c.jam_tanda_tangan
    };
    this.isEditing = true;
  }

  cancelForm() {
    this.showForm = false;
    this.isEditing = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = { ...this.form };
      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await PersetujuanReuseSvc.update(this.selectedItem.id, payload);
      } else {
        resp = await PersetujuanReuseSvc.create(payload);
      }
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan Re-Use berhasil disimpan");
        this.showForm = false;
        this.isEditing = false;
        this.selectedItem = null;
        this.form = this.getEmptyForm();
        storePersetujuanReuse.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  get canEdit() {
    if (this.readOnly) return false;
    return this.selectedItem && !this.selectedItem.is_locked;
  }
  get canDelete() {
    if (this.readOnly || !this.selectedItem) return false;
    return !alasanTtdMengunciHapus(
      this.selectedItem.creator_user_id,
      [
        ...slotTandaTanganDokumen(this.selectedItem.signed_dpjp, this.selectedItem.signature_dpjp),
        { ditandatangani: this.selectedItem.signed_penyetuju, penandaTanganId: null },
        { ditandatangani: this.selectedItem.signed_saksi_keluarga, penandaTanganId: null },
        ...slotTandaTanganDokumen(this.selectedItem.signed_saksi_rs, this.selectedItem.signature_saksi_rs)
      ],
      this.stateuser?.id
    );
  }
  get canSignDpjp() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_dpjp) return false;
    return this.selectedItem.dpjp?.id == this.stateuser?.id;
  }
  get canSignSaksiRs() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_saksi_rs) return false;
    if (this.selectedItem.saksi_rs && this.selectedItem.saksi_rs.id != this.stateuser?.id) return false;
    return true;
  }
  get canMarkPenyetuju() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_penyetuju;
  }
  get canMarkSaksiKeluarga() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_saksi_keluarga;
  }

  get markLabel() {
    return ({
      penyetuju: "Yang Menyatakan",
      saksi_keluarga: "Saksi Keluarga"
    } as any)[this.markRole] || "";
  }

  openMarkPenyetuju() {
    this.markRole = "penyetuju";
    this.markName = this.selectedItem?.penyetuju_nama || "";
    this.modalMark = true;
  }
  openMarkSaksiKeluarga() {
    this.markRole = "saksi_keluarga";
    this.markName = this.selectedItem?.saksi_keluarga_nama || "";
    this.modalMark = true;
  }

  async submitMark() {
    const fns: Record<string, Function> = {
      penyetuju: (id, payload) => PersetujuanReuseSvc.markPenyetuju(id, { penyetuju_nama: payload }),
      saksi_keluarga: (id, payload) => PersetujuanReuseSvc.markSaksiKeluarga(id, { saksi_keluarga_nama: payload })
    };
    const fn = fns[this.markRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, this.markName);
    if (resp.data.status == "1") {
      this.modalMark = false;
      appModule.NoticeDelay(resp.data.message);
      this.selectedItem = null;
      storePersetujuanReuse.getByRegister(this.register);
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const fns: Record<string, Function> = {
      dpjp: PersetujuanReuseSvc.signDpjp,
      saksi_rs: PersetujuanReuseSvc.signSaksiRs
    };
    const labels: Record<string, string> = {
      dpjp: "DPJP",
      saksi_rs: "Saksi RS"
    };
    const fn = fns[this.signRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${labels[this.signRole]}`);
      appModule.addMsgTtd("");
      this.selectedItem = null;
      storePersetujuanReuse.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf() {
    PersetujuanReuseSvc.print(this.selectedItem.id);
  }

  async remove() {
    if (!this.canDelete) return;
    if (!confirm("Anda yakin akan menghapus Persetujuan Re-Use ini?")) return;
    this.deleting = true;
    try {
      const resp = await PersetujuanReuseSvc.destroy(this.selectedItem.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        this.selectedItem = null;
        storePersetujuanReuse.getByRegister(this.register);
      }
    } finally {
      this.deleting = false;
    }
  }
}
